window.focusFirstMissingFileType = (containerId) => {
    const container = document.getElementById(containerId);
    if (!container) return;

    const invalidSelect = container.querySelector('select[data-filetype-invalid="true"]');
    if (invalidSelect) {
        invalidSelect.scrollIntoView({ behavior: "smooth", block: "center" });
        invalidSelect.focus();
        return;
    }

    const err = container.querySelector("span.text-danger");
    if (err) {
        err.scrollIntoView({ behavior: "smooth", block: "center" });
    }
};